import { ENDPOINTS, get } from '~/api'
import { ConfigManager } from '~/managers/ConfigManager'
import { selectIsOtcTrxHistoryEnabled } from '~/store/flippers/selectors'
import { selectIsFiatWalletOnly } from '~/store/route/selectors'
import { Dispatch, GetState } from '~/store/types'
import { FIAT_WALLET_TX_TYPES, FUNDING_TX_TYPES, OTC_TX_TYPES, SWAP_TX_TYPES } from './helpers'
import {
  ActionTypes,
  STRAITSX_TRANSACTIONS_ACTIONS,
  Transaction,
  TRANSACTIONS_ACTIONS,
} from './types'

const setLatestTransactions = (transactions: Transaction[] | null) => (
  dispatch: Dispatch<ActionTypes>
) => {
  const isAppSite = ConfigManager.isAppSite()

  // TODO(benedictkhoo): remove after deduplicate root state
  if (isAppSite) {
    dispatch({
      type: TRANSACTIONS_ACTIONS.SET_LATEST_PERSONAL_TRANSACTIONS,
      latestPersonalTransactions: transactions,
    })
  } else {
    dispatch({
      type: STRAITSX_TRANSACTIONS_ACTIONS.SET_LATEST_TRANSACTIONS,
      latestTransactions: transactions,
    })
  }
}

export const resetLatestTransactions = () => (dispatch: Dispatch<ActionTypes>) => {
  dispatch(setLatestTransactions(null))
}

export const fetchLatestTransactions = () => async (
  dispatch: Dispatch<ActionTypes>,
  getState: GetState
) => {
  const isOtcTrxHistoryEnabled = selectIsOtcTrxHistoryEnabled(getState())
  const isFiatWalletOnly = selectIsFiatWalletOnly(getState())
  let latestTxTypes = isFiatWalletOnly
    ? [...FIAT_WALLET_TX_TYPES]
    : [...FUNDING_TX_TYPES, ...SWAP_TX_TYPES]

  if (isOtcTrxHistoryEnabled) {
    latestTxTypes = [...latestTxTypes, ...OTC_TX_TYPES]
  }

  const response = await get(
    ENDPOINTS.API_DASHBOARD_TRANSACTIONS,
    `?transaction_types=${latestTxTypes}&current_page=1&page_limit=3`
  )

  const transactions = (response.transactions as unknown[]).map(i => i as Transaction)

  dispatch(setLatestTransactions(transactions))
}

export const getFiatDepositTotalCount = () => async (dispatch: Dispatch<ActionTypes>) => {
  const subRoute = `?transaction_types=deposit`

  const resp = await get(ENDPOINTS.API_XFERS_TRANSACTIONS_TOTAL_COUNT, subRoute)

  if (resp.total_count > 0) {
    dispatch({
      type: TRANSACTIONS_ACTIONS.SET_IS_USER_HAS_FIAT_DEPOSIT,
      isUserHasFiatDeposit: true,
    })
  } else {
    dispatch({
      type: TRANSACTIONS_ACTIONS.SET_IS_USER_HAS_FIAT_DEPOSIT,
      isUserHasFiatDeposit: false,
    })
  }
}

export const getFiatWithdrawalTotalCount = () => async (dispatch: Dispatch<ActionTypes>) => {
  const subRoute = `?transaction_types=withdrawal`

  const resp = await get(ENDPOINTS.API_XFERS_TRANSACTIONS_TOTAL_COUNT, subRoute)

  if (resp.total_count > 0) {
    dispatch({
      type: TRANSACTIONS_ACTIONS.SET_IS_USER_HAS_FIAT_WITHDRAWAL,
      isUserHasFiatWithdrawal: true,
    })
  } else {
    dispatch({
      type: TRANSACTIONS_ACTIONS.SET_IS_USER_HAS_FIAT_WITHDRAWAL,
      isUserHasFiatWithdrawal: false,
    })
  }
}

export const getStablecoinDepositTotalCount = () => async (dispatch: Dispatch<ActionTypes>) => {
  const subRoute = `?transaction_types=stablecoin_deposit`

  const resp = await get(ENDPOINTS.API_XFERS_TRANSACTIONS_TOTAL_COUNT, subRoute)

  if (resp.total_count > 0) {
    dispatch({
      type: TRANSACTIONS_ACTIONS.SET_IS_USER_HAS_STABLECOIN_DEPOSIT,
      isUserHasStablecoinDeposit: true,
    })
  } else {
    dispatch({
      type: TRANSACTIONS_ACTIONS.SET_IS_USER_HAS_STABLECOIN_DEPOSIT,
      isUserHasStablecoinDeposit: false,
    })
  }
}

export const getStablecoinWithdrawalTotalCount = () => async (dispatch: Dispatch<ActionTypes>) => {
  const subRoute = `?transaction_types=stablecoin_withdrawal`

  const resp = await get(ENDPOINTS.API_XFERS_TRANSACTIONS_TOTAL_COUNT, subRoute)

  if (resp.total_count > 0) {
    dispatch({
      type: TRANSACTIONS_ACTIONS.SET_IS_USER_HAS_STABLECOIN_WITHDRAWAL,
      isUserHasStablecoinWithdrawal: true,
    })
  } else {
    dispatch({
      type: TRANSACTIONS_ACTIONS.SET_IS_USER_HAS_STABLECOIN_WITHDRAWAL,
      isUserHasStablecoinWithdrawal: false,
    })
  }
}
